const StudentBlocked = () => {
  return (
    <div className="container mx-auto text-center p-5">
      <div
        role="alert"
        className="w-full rounded-lg bg-red-100 border border-red-400 text-red-700 font-bold px-4 py-3"
      >
        قام المدرس بمنعك من دخول الحصص، تواصل مع المدرس
      </div>
    </div>
  );

  // return (
  //   <div className="container text-center p-5 m-auto">
  //     <div className="alert alert-danger fw-bold rounded-ea w-100" role="alert">
  //       قام المدرس بمنعك من دخول الحصص , تواصل مع المدرس
  //     </div>
  //   </div>
  // );
};

export default StudentBlocked;
